import { DlVault } from 'types/contracts';

export interface GetAllUsersInNetworkInput {
  dlVaultContract: DlVault;
  accountAddress: string;
  maxLevels: number;
}

export type GetAllUsersInNetworkOutput = {
  allUsers: string[];
  levels: number[];
  totalCount: number;
};

const getAllUsersInNetwork = async ({
  dlVaultContract,
  accountAddress,
  maxLevels,
}: GetAllUsersInNetworkInput): Promise<GetAllUsersInNetworkOutput> => {
  const result = await dlVaultContract.methods
    .getAllUsersInNetwork(accountAddress, maxLevels)
    .call();

  return {
    allUsers: Array.isArray(result.allUsers) ? result.allUsers : [],
    levels: Array.isArray(result.levels) 
      ? result.levels.map((level: string) => parseInt(level, 10))
      : [],
    totalCount: parseInt(result.totalCount || '0', 10),
  };
};

export default getAllUsersInNetwork; 